export default __webpack_public_path__ + "static/media/app_stores_qr_code.28831318.svg";